import { USE_PRODUCTS_SERVICE, USE_PRODUCT_DATA_CACHING, fetchGraphql } from '@ori/fetching';
import { mapProductBoxesFromGql } from '@ori/product-box';
import type { MappedProductBoxProps } from '@ori/product-box';

import type { GetFavoriteProducts } from './types';
import type {
  GetFavoriteProductsQuery,
  GetFavoriteProductsQueryVariables,
} from '../models/graphql-types/operations';
import { favoriteProductsQuery } from '../queries';

export const getFavoriteProducts = async ({
  currentLanguage,
  graphqlUrl,
  productCodes,
  sourceAppName,
  tenant,
  token,
  customerId,
}: GetFavoriteProducts): Promise<MappedProductBoxProps[] | null> => {
  const { products } = await fetchGraphql<
    GetFavoriteProductsQuery,
    GetFavoriteProductsQueryVariables
  >({
    query: favoriteProductsQuery,
    sourceAppName,
    url: graphqlUrl,
    customerId,
    headers: {
      [USE_PRODUCTS_SERVICE]: true,
      [USE_PRODUCT_DATA_CACHING]: true,
    },
    language: currentLanguage,
    tenant,
    token,
    variables: {
      productCodes,
    },
  });

  // @ts-expect-error -- toolbox bug
  return products ? mapProductBoxesFromGql(products) : null;
};
